import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from "rxjs";

import { AppService } from "../_services/app.service";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";

@Component({
  selector: "side-nav",
  standalone: true,
  imports: [CommonModule, MatIconModule, MatListModule, MatTooltipModule, RouterModule],
  styleUrls: ["./sidenav.component.scss"],
  template: `
    <section [class.sidenav]="isExpanded" [class.sidenav-closed]="!isExpanded" class="flex-column">
      <div class="toggle">
        <mat-icon (click)="toggleMenu.emit(null)">
          {{ isExpanded ? "keyboard_backspace" : "dehaze" }}
        </mat-icon>
      </div>
      <ng-container *ngFor="let route of routeLinks">
        <mat-list *ngIf="route.link > ''" class="nav">
          <a
            mat-list-item
            routerLinkActive="active-link"
            class="hover"
            routerLink="{{ route.link }}"
            (click)="checkIfClose()"
          >
            <mat-icon
              class="icon"
              mat-list-icon
              [matTooltip]="!isExpanded ? route.name : ''"
              [matTooltipDisabled]="isExpanded"
              matTooltipPosition="right"
            >
              {{ route.icon }}</mat-icon
            >
            <span class="text" *ngIf="isExpanded">{{ route.name }}</span>
          </a>
        </mat-list>
        <div *ngIf="route.link == ''" class="flex">
        </div>
      </ng-container>
      <div class="version">v{{appSvc.version}}</div>
    </section>
  `,
})
export class SidenavComponent implements OnInit, OnDestroy {
  @Input() isExpanded: boolean = false;
  @Output() toggleMenu = new EventEmitter();

  deviceType = 'desktop';

  public routeLinks = [
    { link: "main", name: "Dashboard", icon: "dashboard" },
    { link: "campaigns", name: "Campañas", icon: "campaigns" },
    { link: "lists", name: "Listas", icon: "list" },
    { link: "flows", name: "WorkFlows", icon: "account_tree" },
    { link: "profiles", name: "Perfiles", icon: "groups" },
    { link: "templates", name: "Plantillas", icon: "web" },
    { link: "popups", name: "Popups", icon: "call_to_action" },
    { link: "", name: "", icon: "", flex: true},
    { link: "/clients/" + this.appSvc.selectedClient.id, name: "Ajustes", icon: "settings" },
  ];
  dataSubscription?: Subscription;

  constructor(
    public appSvc: AppService,
    private responsive: BreakpointObserver,
  ) {
  }

  checkIfClose() {
    if (this.deviceType === 'handset') {
      this.toggleMenu.emit(null);
    }
  }

  ngOnInit(): void {
    this.dataSubscription = this.appSvc.updateData.subscribe((res: any) => {
      this.routeLinks[8].link = "/clients/" + this.appSvc.selectedClient.id;
    });
    this.responsive.observe(
      Breakpoints.Handset
    ).subscribe((result: BreakpointState) => {
      const breakpoints = result.breakpoints;
      if (breakpoints[Breakpoints.HandsetPortrait]) {
        this.deviceType = 'handset';
      }
    });
  }

  ngOnDestroy(): void {
    this.dataSubscription?.unsubscribe();
  }

}
